import DOMPurify from "dompurify";
import { useSite } from "@/context/SiteContext";

// Renders an editable text snippet by key. Inline mode neutralises any block
// wrapping (<p>) so it can be used inside headings, buttons and labels.
export default function Snippet({ k, fallback = "", as: Tag = "span", inline = true, className = "", ...rest }) {
  const { snip } = useSite();
  const html = snip(k, fallback);
  const inlineFix = inline ? " [&>p]:m-0 [&>p]:p-0 [&>p]:inline [&_ul]:m-0 [&_ul]:inline" : "";
  return (
    <Tag
      className={`${className}${inlineFix}`}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
      {...rest}
    />
  );
}
